import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

const ToastContext = createContext(null)

const errorMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback

export function ToastProvider ({ children }) {
  const [toast, setToast] = useState(null)

  const showToast = useCallback((message, severity = 'success') => {
    setToast({ message, severity })
  }, [])

  const showError = useCallback((err, fallback = 'Operation failed') => {
    setToast({ message: errorMessage(err, fallback), severity: 'error' })
  }, [])

  const value = useMemo(() => ({ showToast, showError }), [showToast, showError])

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Snackbar
        open={!!toast}
        autoHideDuration={4000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {toast && (
          <Alert onClose={() => setToast(null)} severity={toast.severity} variant='filled' elevation={6}>
            {toast.message}
          </Alert>
        )}
      </Snackbar>
    </ToastContext.Provider>
  )
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export const useToast = () => {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used inside ToastProvider')
  return ctx
}
